"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var makeStyles_1 = __importDefault(require("../../../util/makeStyles"));
exports.default = (0, makeStyles_1.default)(function () {
    return (0, core_1.createStyles)({
        root: {
            display: 'flex',
            alignItems: 'center',
        },
        errorIcon: {
            cursor: 'pointer',
        },
        hoverable: {
            cursor: 'pointer',
        },
        nameContainer: function (_a) {
            var large = _a.large;
            return ({
                marginLeft: large ? 24 : 12,
                display: 'flex',
                flexDirection: 'column',
            });
        },
        userName: function (_a) {
            var large = _a.large;
            return ({
                marginBottom: large ? 4 : 0,
            });
        },
        email: {},
    });
});
